import(/* webpackMode: "eager" */ "/vercel/path0/src/app/thank-you/page.tsx");
